import React, { useEffect, useState } from "react"; import * as OFMSUI from "react-bootstrap"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader"; import { useHistory } from "react-router-dom/cjs/react-router-dom.min"; import HousingService from "../../../Services/HousingService"; import Swal from "sweetalert2"; import { FaDownload, FaFastBackward } from "react-icons/fa"; import axios from "axios"; import { cloud_url_download } from "../../../Services/Configuration";
import { MdOutlinePictureAsPdf } from "react-icons/md"; import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { DashboardServiceReport, generatePDF, ModuleHeader } from "../../utils/commonFunctions";
import { store } from "../../../App";
const BankAccountConfirm = () => {
  const history = useHistory();
  const [BankDetails, setBankDetails] = useState([]);
  const [district, setDistrict] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" });
    const params = { code: "All" };
    Promise.all([
      HousingService.GetBankDetailsToBeConfirmByGmf(params),
      HousingService.CGG_District(),
    ]).then(([bankRes, districtRes]) => {
      if (bankRes.data && bankRes.data.length > 0) {
        setBankDetails(bankRes.data);
      } else {
        setBankDetails([]);
      }
      if (districtRes.data && districtRes.data.length > 0) {
        setDistrict(districtRes.data);
      } else {
        setDistrict([]);
      }
    }).catch((error) => {
      console.error("Error fetching data:", error);
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  }, []);

  const [selectedDistrictCode, setSelectedDistrictCode] = useState("");
  const handleDistrictChange = (event) => { setSelectedDistrictCode(event.target.value); };

  const handleCheckboxClick = (index) => { if (selectedRows.includes(index)) { setSelectedRows(selectedRows.filter((i) => i !== index)); } else { setSelectedRows([...selectedRows, index]); } };

  const showNotification = (type, message) => { if (type === "success") { Swal.fire("Success", message, "success"); } else if (type === "error") { Swal.fire("Error", message, "error"); } else if (type === "warning") { Swal.fire("Warning", message, "warning"); } else if (type === "info") { Swal.fire("info", message, "info"); } };

  const handleSubmit = () => {
    if (selectedDistrictCode) {
      store.dispatch({ type: "SHOW_SPINNER" });
      const params = { code: selectedDistrictCode };
      HousingService.GetBankDetailsToBeConfirmByGmf(params).then((res) => {
        if (res.data) {
          setBankDetails(res.data);
        }
        else { setBankDetails([]) };
      }).catch((error) => {
        console.error("Error fetching Bank Name Account Number:", error);
      }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    }
  };

  const handleConfirm = () => {
    if (selectedRows.length > 0) {
      const selectedRowsData = selectedRows.map((index) => BankDetails[index]);
      const requestBody = selectedRowsData.map((row) => ({
        status: "update",
        banknameaccountno: row.banknameaccountno
      }));
      Swal.fire({
        text: "Are You Sure Want to Confirm?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(async (result) => {
        if (result.isConfirmed) {
          const Update = await HousingService.UpdateBankDetainlsConfirm(requestBody);
          if (Update?.data?.SCODE === "01") {
            showNotification("success", "Confirmed successfully By GMF");
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          }
        }
      });
    } else {
      showNotification("warning", "Please Select CheckBox ");
    }
  };


  const handleDelete = () => {
    if (selectedRows.length > 0) {
      const selectedRowsData = selectedRows.map((index) => BankDetails[index]);
      const requestBody = selectedRowsData.map((row) => ({
        status: "delete",
        banknameaccountno: row.banknameaccountno
      }));
      Swal.fire({
        text: "Are You Sure Want to Delete?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(async (result) => {
        if (result.isConfirmed) {
          const Update = await HousingService.UpdateBankDetainlsConfirm(requestBody);
          if (Update?.data?.SCODE === "01") {
            showNotification("success", "Deleted successfully By GMF");
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          }
        }
      });
    } else {
      showNotification("warning", "Please Select CheckBox ");
    }
  };


    const fileDownload = (upload_copy, index) => {
      if (upload_copy == null) { showNotification("error", "No File Uploaded"); } else {
        setHiddenIcons((prevHiddenIcons) => ({ ...prevHiddenIcons, [index]: true }));
        axiosTokenServiceKeyCloak({
          url: `${cloud_url_download}apofms/Pay_Rec&file=${encodeURIComponent(upload_copy)}`, method: "GET", responseType: "blob"
        })
          .then((response) => {
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
  
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = upload_copy;
  
            link.click(); window.URL.revokeObjectURL(link.href); setHiddenIcons((prevHiddenIcons) => ({ ...prevHiddenIcons, [index]: false }));
          })
          .catch((error) => {
            console.error("Error downloading file:", error);
            setHiddenIcons((prevHiddenIcons) => ({ ...prevHiddenIcons, [index]: false }));
  
            if (error.response && error.response.status === 500) {
              showNotification("error", "File Was Deleted, Upload the File Again");
            } else { showNotification("error", "An error occurred while downloading the file"); }
          });
      }
    };

  return (
    <div>
      <NavigationServicesHeader />
      <ModuleHeader title="Bank Account Confirmation" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <DashboardServiceReport title="Service" />
        <OFMSUI.Row>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} ></OFMSUI.Col>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
            <label> <b>District</b> </label>
            <select value={selectedDistrictCode} onChange={handleDistrictChange} className="form-control" > <option value="All">All</option> {district.map((dist) => (<option key={dist.code} value={dist.code}> {dist.name} </option>))} </select>
          </OFMSUI.Col>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="m-4" > <button type="button" className="btn btn-primary btn-sm" onClick={handleSubmit} > Get Details </button> </OFMSUI.Col>
        </OFMSUI.Row>
        <OFMSUI.Row>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
            <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff", fontSize: "12px" }} > <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table" filename="BankAccountConfirmation" sheet="tablexls" buttonText="Excel" ></ReactHTMLTableToExcel> </button>
            <button type="button" className="btn btn-danger btn-sm" onClick={() => generatePDF("my-table", "Bank Account Confirmation", "BankAccountConfirmation.pdf", 7)} style={{ float: "right", fontSize: "12px" }} >
              PDF
              <MdOutlinePictureAsPdf />
            </button>
          </OFMSUI.Col>
        </OFMSUI.Row>

        <OFMSUI.Table striped bordered hover id="my-table">
          <thead className="fw-bold">
            <tr> <td colSpan={22} style={{ textAlign: "center" }}> District-Wise Bank Accounts to be confirmed </td> </tr>
            <tr className="table_countshead"> <th>S No.</th> <th style={{ width: "9%" }}> District Name</th> <th> Bank Name </th> <th>Bank Account No</th> <th>Branch </th> <th>IFSC </th> <th>Opening Balance</th> <th>Scaned Copy</th> <th>Confirm/Delete </th> </tr>
          </thead>
          <tbody>
            {BankDetails && BankDetails.length > 0 ? (
              BankDetails.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.security_name}</td> <td>{item.bankname}</td> <td>{item.accountno}</td>
                  <td>{item.branchname}</td> <td>{item.ifsc}</td> <td>{item.balance}</td>
                  <td style={{ fontSize: "21px", color: "green", textAlign: "center", }} > <FaDownload onClick={() => fileDownload(item.passbook_path, index)} /> </td>
                  <td> <input type="checkbox" onClick={() => { handleCheckboxClick(index); }} /> </td>
                </tr>
              ))
            ) : (
              <tr> <td colSpan="9" className="text-center text-danger"> No Data Found </td> </tr>
            )}
          </tbody>
        </OFMSUI.Table>
        <div style={{ textAlign: "center" }}> <button className="btn btn-success btn-sm" onClick={handleConfirm}> Confirm </button> <button className="btn btn-danger btn-sm" onClick={handleDelete}> Delete </button> </div>
      </OFMSUI.Container>
    </div>
  );
};

export default BankAccountConfirm;
